module.exports = __webpack_public_path__ + "static/004-fa3bf36f9e7b575589b70be7ca8a1bd0.jpg";